<template>
  <div v-if="visible" class="set-max-bind-number-modal-container">
    <div class="set-max-bind-number-modal">
      <div class="header-bg"></div>
      <div class="close-btn" @click="handleClose"></div>
      <div class="content">
        <div>最大绑定数设置</div>
        <div class="number-radio-group mt-20">
          <div :class="['radio-item', { active: maxNumber === 70 }]" @click="maxNumber = 70">70台</div>
          <div :class="['radio-item', { active: maxNumber === 100 }]" @click="maxNumber = 100">100台</div>
        </div>
        <div class="tips mt-10">
          温馨提示：保存设置后，需要关闭软件重新打开才能生效，且当设置为100台时，接收器必须接通电源才能正常使用
        </div>
      </div>
      <a-divider />
      <div class="btn-group">
        <div class="btn confirm" @click="handleConfirm">保存设置</div>
        <div class="btn cancel" @click="handleClose">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendMessage } from '@/utils/dtq'
import { mapActions } from 'vuex'

export default {
  name: 'SetMaxBindNumberModal',
  data() {
    return {
      visible: false,
      maxNumber: 70
    }
  },
  computed: {
    receiverInfo() {
      return this.$store.state.app.receiverInfo
    }
  },
  methods: {
    ...mapActions('app', ['setReceiverInfo']),
    show() {
      this.maxNumber = this.receiverInfo?.wl_max || 70
      this.visible = true
    },
    handleConfirm() {
      if (this.maxNumber === this.receiverInfo?.wl_max) return
      sendMessage({ fun: 'wl_max_set', wl_max: this.maxNumber })
      this.setReceiverInfo({ ...this.receiverInfo, wl_max: this.maxNumber })
      this.handleClose()
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.set-max-bind-number-modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .set-max-bind-number-modal {
    position: relative;
    width: 450px;
    background: #ffffff;
    border-radius: 32px;
    padding: 75px 40px 28px 40px;
    .header-bg {
      position: absolute;
      top: -70px;
      left: 50%;
      transform: translateX(-50%);
      width: 370px;
      height: 150px;
      background-image: url('@/assets/login/authority-icon.png');
      background-size: 100% 100%;
    }
    .close-btn {
      position: absolute;
      top: 26px;
      right: 26px;
      width: 20px;
      height: 20px;
      background-image: url('@/assets/common/close.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    .content {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      .number-radio-group {
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px;
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        background: #f6f6f6;
        border-radius: 6px;
        .radio-item {
          height: 100%;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #f6f6f6;
          cursor: pointer;
          &.active {
            color: #1976ff;
            background: #fff;
            border-radius: 6px;
          }
        }
      }

      .tips {
        font-size: 17px;
        color: #ff3c30;
      }
    }
    .btn-group {
      display: flex;
      justify-content: space-between;
      gap: 28px;

      .btn {
        flex: 1;
        height: 54px;
        font-weight: 400;
        font-size: 17px;
        border-radius: 100px;
        text-align: center;
        line-height: 54px;
        cursor: pointer;
        &.cancel {
          background: #f6f6f6;
          color: #666666;
        }
        &.confirm {
          background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
          color: #ffffff;
        }
        &.error {
          background: #ff3c30;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
